import {
  toString, isString, snakeCase, startsWith,
  replace,
} from 'lodash';
import { Snackbar } from '@client/components/globals/Snackbar';
import { Analytics } from '../../client/js/components/_helpers/Analytics';
import type { AnyAction } from '@reduxjs/toolkit';

export type IntercomMethod =
  | 'boot'
  | 'shutdown'
  | 'update'
  | 'hide'
  | 'show'
  | 'showMessages'
  | 'showNewMessage'
  | 'onHide'
  | 'onShow'
  | 'onUnreadCountChange'
  | 'trackEvent'
  | 'getVisitorId'
  | 'startTour'
  | 'showArticle';

export const setAcceptsCookies = (acceptsCookies: boolean): void => {
  Analytics.setAcceptsCookies(acceptsCookies);
};

export const trackAnalytics = (eventName: string | AnyAction, eventData?: unknown) => {
  let eventString = eventName;

  if (!isString(eventString)) {
    const str = toString(eventName);
    const [,event] = str.split('/');

    if (startsWith(event, 'start')) {
      eventString = replace(event, 'start', '');
    } else {
      eventString = event;
    }

    eventString = snakeCase(eventString).toUpperCase();
  }

  Analytics.track(eventString, eventData);
};

export const updateIntercom = (data: unknown): void => {
  if (window && window.Intercom) {
    window.Intercom('update', data);
  }
};

export const bootIntercom = (hideLauncher?: boolean): void => {
  if (window && window.Intercom) {
    window.Intercom('boot', {
      app_id: process.env.INTERCOM_APP_ID,
    });

    const hidden = hideLauncher || (!hideLauncher && hideLauncher !== false);

    updateIntercom({
      hide_default_launcher: hidden,
      alignment: 'right',
    });
  }
};

export const shutdownIntercom = (): void => {
  if (window.Intercom) {
    window.Intercom('shutdown');

    bootIntercom();
  }
};

export const showIntercom = () => {
  if (window && window.Intercom) {
    window.Intercom('show');
  } else {
    Snackbar.show({
      severity: 'error',
      body: 'Unable to launch support tool. We use Intercom to help us manage our support requests, but you have blocked it with your browser. Please enable Intercom and try again.',
    });
  }
};
